var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.block.attributes.content && this.block.attributes.content != '')?_c('p',{class:{
		['color-' + _vm.block.attributes.textColor]: true,
		['font-size-' + _vm.block.attributes.fontSize]: _vm.block.attributes.fontSize,
		'font-size-16': !_vm.block.attributes.fontSize,
	},domProps:{"innerHTML":_vm._s(_vm.block.attributes.content)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }